<div class="options">
  <div class="container">
    <div class="options-wrapper d-flex">
      <div class="choose-option">
        <h3>{{ "choose-your-category" | translate }}</h3>

        <div class="slider">
          <owl-carousel-o [options]="customOptionsSliderOne">
            <ng-template carouselSlide *ngFor="let category of categories">
              <div class="slider-item">
                <img
                  loading="lazy"
                  [src]="'/assets/images/home/categories/' + category.image"
                  [alt]="category.title"
                />
                <p>{{ "categories." + category.title | translate }}</p>
              </div>
            </ng-template>
          </owl-carousel-o>
        </div>

        <img
          loading="lazy"
          class="logo"
          [src]="
            currentLang === ApplicationLanguages.Ar
              ? '/assets/images/logo-cutout.svg'
              : '/assets/images/logo-cutout-en.svg'
          "
          alt="madfu"
        />
      </div>

      <!--
      <div class="all-options">
        <div class="all-options-wrapper d-flex">
          <div class="option" *ngFor="let category of categories">
            <img
              loading="lazy"
              class="image"
              [src]="'/assets/images/home/categories/' + category.image"
              [alt]="'categories.' + category.title | translate"
            />
            <p class="title">
              {{ "categories." + category.title | translate }}
            </p>
          </div>
        </div>
      </div>
      -->
    </div>
  </div>
</div>
